import axiosClient from "./axiosClient";

const itemTypeApi = {
  getAll: () => {
    return axiosClient.get("/item_type/get-all", { withCredentials: true });
  },
};

export default itemTypeApi;
